"use client";

import { AdSlot } from "@/components/ads/ad-slot";
import { SidebarSectionTitle } from "@/components/shared/main/sidebar-primitives";

/**
 * 專題 — the home right-rail stack of six 300×100 / 300×90 banners that hkej.com sells as
 * HKEJ_HomePage_Features_RightBanner1-6. No shared 廣告 band: each unit is its own slot.
 * The row count follows the banner width: two or three across a tablet, one
 * in the desktop rail and on a phone. Each creative is scaled to the cell.
 * The card border matches the 即時 sidebar item.
 */
const COUNT = 6;

export function FeatureTopicAdRail() {
  return (
    <section
      className="flex w-full flex-col gap-[12px] p-[20px]"
      style={{ border: "1px solid rgba(0,0,0,0.3)", borderRadius: 8 }}
    >
      <SidebarSectionTitle>專題</SidebarSectionTitle>
      {/* As many 300px banners as fit the row. A cell narrower than 300px
          (the phone, and the desktop rail) takes the whole row. The creative
          is scaled to that cell so the sides of the card are not empty. */}
      <div
        className="grid w-full gap-[12px]"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))" }}
      >
        {Array.from({ length: COUNT }, (_, i) => (
          <AdSlot key={i} unit={`RightBanner${i + 1}`} className="w-full" fillWidth />
        ))}
      </div>
    </section>
  );
}
